type TipProps = React.HTMLAttributes<SVGElement>
export const Tip = (props: TipProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="40"
    viewBox="0 0 13 40"
    fill="none"
  >
    <path
      d="M13 -5.54042e-07L12.9972 -5.53923e-07C12.9863 1.97419 12.933 3.14578 12.6718 4.15282C12.3808 5.27437 11.9011 6.34432 11.251 7.32168C10.5178 8.42419 9.49335 9.36095 7.44454 11.2345L3.66581 14.69C1.63992 16.5425 0.62697 17.4688 0.249143 18.5441C-0.0830465 19.4896 -0.0830464 20.5113 0.249143 21.4568C0.62697 22.5321 1.63991 23.4584 3.6658 25.3109L7.44454 28.7664C9.49335 30.6399 10.5178 31.5767 11.251 32.6792C11.9011 33.6566 12.3808 34.7265 12.6718 35.8481C12.9245 36.8221 12.9826 38.0136 12.996 40L13 40L13 -5.54042e-07Z"
      fill="currentColor"
    />
  </svg>
)
